import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/ticket").then((module) => ({
    default: module.TicketPage,
  })),
);

export const Route = createFileRoute("/admin/support/$ticketId")({
  component: Page,
});
